import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'svgDarkModeSuffix',
    standalone: false
})
export class SvgDarkModeSuffixPipe implements PipeTransform {
  transform(value: string) {
    return value?.replace('.svg', '-dark.svg');
  }
}